export class MPAPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        },
        {
            "name": "requiredApprovals",
            "baseName": "requiredApprovals",
            "type": "number",
            "format": ""
        },
        {
            "name": "approvalWindowHours",
            "baseName": "approvalWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "executionWindowHours",
            "baseName": "executionWindowHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "MPAResourceSelector",
            "format": ""
        },
        {
            "name": "approverIdpGroupId",
            "baseName": "approverIdpGroupId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return MPAPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
